import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import Privacy from "@/pages/Privacy";
export const Route = createFileRoute("/privacy")({ head: ({match}) => pageHead(match.pathname), component: () => (<Privacy />) });
